var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import WixComponent from '../BaseComponents/WixComponent';
import Languages from '../Icons/dist/components/Languages';
import ButtonWithOptions from '../ButtonWithOptions/ButtonWithOptions';

var LanguagePicker = function (_WixComponent) {
  _inherits(LanguagePicker, _WixComponent);

  function LanguagePicker() {
    _classCallCheck(this, LanguagePicker);

    return _possibleConstructorReturn(this, (LanguagePicker.__proto__ || Object.getPrototypeOf(LanguagePicker)).apply(this, arguments));
  }

  _createClass(LanguagePicker, [{
    key: 'createDividedChildren',
    value: function createDividedChildren() {
      var dividerChild = React.cloneElement(this.props.children[0], {
        children: '-',
        languageKey: '-'
      });

      var dividedChildren = [].concat(_toConsumableArray(this.props.children));
      dividedChildren.forEach(function (_, index) {
        return dividedChildren.splice(index * 2 + 1, 0, dividerChild);
      });
      dividedChildren.pop();

      return dividedChildren;
    }
  }, {
    key: 'createButtonWithOptionsOptions',
    value: function createButtonWithOptionsOptions() {
      var dividedChildren = this.createDividedChildren();

      return dividedChildren.map(function (languagePickerOption) {
        var languageKey = languagePickerOption.props.languageKey;

        var languageName = languagePickerOption.props.children;

        return React.createElement(
          ButtonWithOptions.Option,
          { key: languageKey, id: languageKey },
          languageName
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dataHook = _props.dataHook,
          theme = _props.theme,
          _onSelect = _props.onSelect,
          dropdownWidth = _props.dropdownWidth,
          dropdownOffsetLeft = _props.dropdownOffsetLeft;

      return React.createElement(
        ButtonWithOptions,
        {
          dataHook: dataHook,
          onSelect: function onSelect(option) {
            return _onSelect(option.id);
          },
          dropdownWidth: dropdownWidth,
          dropdownOffsetLeft: dropdownOffsetLeft
        },
        React.createElement(
          ButtonWithOptions.Button,
          { type: 'button', height: 'medium', theme: theme },
          React.createElement(Languages, { size: '30px' })
        ),
        this.createButtonWithOptionsOptions()
      );
    }
  }]);

  return LanguagePicker;
}(WixComponent);

export default LanguagePicker;


LanguagePicker.defaultProps = {
  theme: 'icon-greybackground',
  onSelect: function onSelect() {},
  dropdownWidth: '100px',
  dropdownOffsetLeft: '-30px'
};

LanguagePicker.propTypes = {
  dataHook: PropTypes.string,
  onSelect: PropTypes.func,
  theme: PropTypes.string,
  children: PropTypes.arrayOf(function (propValue, key) {
    if (propValue[key].type !== LanguagePicker.Option) {
      return new Error('LanguagePicker: Invalid Prop children was given. Validation failed on child number ' + key);
    }
  }),
  dropdownWidth: PropTypes.string,
  dropdownOffsetLeft: PropTypes.string
};

LanguagePicker.Option = function () {
  return null;
};

LanguagePicker.Option.propTypes = {
  languageKey: PropTypes.string.isRequired,
  children: PropTypes.string
};
//# sourceMappingURL=LanguagePicker.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/LanguagePicker/LanguagePicker.js